import React from "react";
import { Instagram, Facebook } from "lucide-react";
import { BUSINESS } from "@/lib/business";

// TikTok lucide-react doesn't ship with — inline SVG
const TikTokIcon = ({ className = "w-5 h-5" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.3a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.03z" />
  </svg>
);

export const SocialLinks = ({
  variant = "default",
  className = "",
  testIdPrefix = "social",
}) => {
  const items = [
    {
      key: "instagram",
      label: "Instagram",
      href: BUSINESS.social.instagram,
      Icon: Instagram,
      hover: "hover:bg-[#E60000]",
    },
    {
      key: "facebook",
      label: "Facebook",
      href: BUSINESS.social.facebook,
      Icon: Facebook,
      hover: "hover:bg-[#E60000]",
    },
    {
      key: "tiktok",
      label: "TikTok",
      href: BUSINESS.social.tiktok,
      Icon: TikTokIcon,
      hover: "hover:bg-[#FFCC00] hover:text-black",
    },
  ];

  const sizeClass =
    variant === "sm"
      ? "w-9 h-9"
      : variant === "lg"
      ? "w-12 h-12"
      : "w-10 h-10";

  const iconClass =
    variant === "sm"
      ? "w-4 h-4"
      : variant === "lg"
      ? "w-5 h-5"
      : "w-4 h-4";

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {items.map((it) => (
        <a
          key={it.key}
          href={it.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={it.label}
          data-testid={`${testIdPrefix}-${it.key}`}
          className={`inline-flex items-center justify-center ${sizeClass} border border-[#27272A] text-white ${it.hover} transition-all duration-200 hover:-translate-y-0.5 hover:border-transparent`}
        >
          <it.Icon className={iconClass} />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
